import { render } from "./PositionInfos.vue?vue&type=template&id=09847f28"
import script from "./PositionInfos.vue?vue&type=script&lang=js"
export * from "./PositionInfos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__